module.exports = __webpack_public_path__ + "img/colaboration-of-ibff.cfbfa908.jpg";